
// 导入组件，组件必须声明 name
import component from './src/class.vue'

// 为组件添加 install 方法，用于按需引入
component.install = function (Vue) {
    Vue.component(component.name, component)
}

export default component